const edgeEventsState = {
    edgeEventsAlerts: undefined,
    edgeEventsRules: undefined,
    edgeEventsSites: undefined,
    requestingEdgeEventsAlerts: false,
    requestingEdgeEventsRules: false,
    requestingEdgeEventsSites: false,
    requestingModifyEdgeEventsAlert: false,
    requestingRemoveEdgeEventsAlert: false,
    requestingSetEdgeEventsAlert: false
};
export default edgeEventsState;
